var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Body } from 'syf-component-library/ui/typography';
import { CashRewardsBalanceHeader, CashRewardsBalanceNumber, CashRewardsBalanceWrapper, CashRewardsContentWrapper } from './subcomponents';
import useRewards from '../../../hooks/useRewards';
var CashRewardsBalance = function (_a) {
    var _b, _c, _d;
    var className = _a.className;
    var t = useTranslation().t;
    var rewardDetails = useRewards().rewardDetails;
    var cashRewardsBalance = (_b = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.CurrentBalanceDollars) === null || _b === void 0 ? void 0 : _b.value;
    var cashRewardsBalanceCurrency = ((_c = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.CurrentBalanceDollars) === null || _c === void 0 ? void 0 : _c.currencyFormat) === 'DOLLAR';
    var cashRewardsBalanceDisplayName = (_d = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.CurrentBalanceDollars) === null || _d === void 0 ? void 0 : _d.displayName;
    if (!(cashRewardsBalance &&
        cashRewardsBalanceCurrency &&
        cashRewardsBalanceDisplayName)) {
        throw new Error("invalid value either for CurrentBalanceDollars");
    }
    return (_jsxs(CashRewardsContentWrapper, __assign({ className: className }, { children: [_jsx(CashRewardsBalanceHeader, __assign({ "data-cy": "cash-rewards-balance-header" }, { children: t('modal.rewards.earned') })), _jsxs(CashRewardsBalanceWrapper, { children: [_jsxs(CashRewardsBalanceNumber, __assign({ "data-cy": "cash-rewards-balance-value" }, { children: ["$", cashRewardsBalance] })), _jsx(Body, __assign({ "data-cy": "cash-rewards-balance-display-name" }, { children: cashRewardsBalanceDisplayName }))] })] })));
};
export default CashRewardsBalance;
